import HowWorkBG from '@/assets/website/how_work_bg.svg';
import logo from '@/assets/logo.svg';
import logoTitle from '@/assets/logo_title.svg';
import { linkAfterCheckLogin, utilLogin } from '@/utils/checkLogin';
import { useNavigate } from 'react-router-dom';
import Typography from '../typography';

export default function Footer() {
  const navigate = useNavigate();
  const handleOrg = async () => {
    if (localStorage.getItem('token')) {
      if (localStorage.getItem('isInWhiteList') === 'true') {
        linkAfterCheckLogin('/manage/org/edit?type=new', navigate);
      } else {
        window.open('https://tally.so/r/3xXz4o');
      }
    } else {
      await utilLogin();
      window.location.reload();
    }
  };

  return (
    <div className="relative mt-12 w-full pt-4">
      <img
        alt=""
        className="h-[370px] w-full object-cover"
        src={HowWorkBG}
      ></img>
      <div className="absolute left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%] text-sm">
        <div>
          <div className="flex flex-wrap content-start">
            <div className="mr-6 mb-3 flex items-center">
              <img src={logo} alt="logo" className="mr-2 h-7" />
              <img src={logoTitle} alt="logo title" className="h-5" />
            </div>
            <a
              href="https://twitter.com/BuidlerDAO"
              target="_blank"
              rel="noreferrer noopener"
              className="content-center items-center justify-start"
            >
              <Typography
                variant="subTitle"
                className="cursor-pointer items-center font-normal"
              >
                Incubated by @BuidlerDAO
              </Typography>
            </a>
          </div>

          <div className="mt-7 flex w-full">
            <div>
              <p className="mb-3 text-left text-xl font-bold text-[#7adcae]">
                CONTACT
              </p>
              <p className="text-left text-xl leading-8 text-[#4e4e4e]">
                <a
                  href="https://twitter.com/vitae3me"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="content-center items-center justify-start"
                >
                  <Typography
                    variant="subTitle"
                    className="cursor-pointer items-center font-normal"
                  >
                    Twitter
                  </Typography>
                </a>
                <br />
                <a
                  href="https://discord.gg/Bg8Xz7YXWt"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="content-center items-center justify-start"
                >
                  <Typography
                    variant="subTitle"
                    className="cursor-pointer items-center font-normal"
                  >
                    Discord
                  </Typography>
                </a>
              </p>
            </div>
            <div className="... h-14 grow"></div>
            <div className="ml-10">
              <p className="mb-3 text-left text-xl font-bold text-[#7adcae]">
                VITAE
              </p>
              <p className="text-left text-xl leading-8 text-[#4e4e4e]">
                <span
                  className="cursor-pointer text-left text-base text-[#4e4e4e]"
                  onClick={() => handleOrg()}
                  // linkAfterCheckLogin('/manage/org/edit?type=new', navigate)
                  // }
                >
                  Create Space
                </span>
                <br />
                <span
                  className="cursor-pointer text-left text-base text-[#4e4e4e]"
                  onClick={() => linkAfterCheckLogin('/profile', navigate)}
                >
                  My Profile
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
